/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Admin_Commission_Lines_CountInputs */



/**
* | output |
* | --- |
* | "{count} invoice lines" |
*
* @param {Partner_Admin_Commission_Lines_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_lines_count = /** @type {((inputs: Partner_Admin_Commission_Lines_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Lines_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Rechnungsposten`)
	return /** @type {LocalizedString} */ (`${i?.count} invoice lines`)
});